import { z } from "zod";

export const physicalItemSchema = z
  .object({
    email: z
      .string({ required_error: "Email is required" })
      .trim()
      .email({ message: "It's not a valid e-mail address" }),
    confirmEmail: z
      .string({ required_error: "Field is required" })
      .trim()
      .email({ message: "It's not a valid e-mail address" }),
  })
  .superRefine((data, ctx) => {
    if (data.email.toLowerCase() !== data.confirmEmail.toLowerCase()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["confirmEmail"],
        message: "Emails do not match",
      });
    }
  });
